import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/appraise",
  },
  {
    path: "/appraise",
    name: "appraise",
    component: () => import("../views/officialAccount/appraise.vue"),
    meta: {
      title: "售后服务单",
    },
  },
  {
    path: "/workOrderList",
    name: "workOrderList",
    component: () => import("../views/officialAccount/workOrderList.vue"),
    meta: {
      title: "我的工单",
    },
  },
  {
    path: "/workOrderDetails",
    name: "workOrderDetails",
    component: () => import("../views/officialAccount/workOrderDetails.vue"),
    meta: {
      title: "工单详情",
    },
  },
  {
    path: "/workOrderConfirm",
    name: "workOrderConfirm",
    component: () => import("../views/officialAccount/workOrderConfirm.vue"),
    meta: {
      title: "提交成功",
    },
  },
  // 回寄地址管理（保留）
  {
    path: "/addressMana",
    name: "addressMana",
    component: () => import("../views/officialAccount/addressMana.vue"),
    meta: {
      title: "地址管理",
    },
  },
  {
    path: "/addressEdit",
    name: "addressEdit",
    component: () => import("../views/officialAccount/addressEdit.vue"),
    meta: {
      title: "地址管理",
    },
  },
  // === 以下路由暂时注释，新需求不需要 ===
  // {
  //   path: '/deviceList',
  //   name: 'deviceList',
  //   component: () => import('../views/officialAccount/deviceList.vue'),
  //   meta: { title: '售后检修估价' }
  // },
  // {
  //   path: '/expressDelivery',
  //   name: 'expressDelivery',
  //   component: () => import('../views/officialAccount/expressDelivery.vue'),
  //   meta: { title: '填写单号' }
  // },
  // {
  //   path: '/agreement',
  //   name: 'agreement',
  //   component: () => import('../views/officialAccount/agreement.vue'),
  //   meta: { title: '面元售后服务协议' }
  // },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
